import { topicsData } from '@/mocks/homeData';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            探索当前最火爆的话题标签，快速找到你感兴趣的内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group cursor-pointer rounded-full px-5 py-2.5 md:px-6 md:py-3 border transition-all ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-200/50'
              }`}
            >
              <div className="flex items-center gap-2">
                <span className={`text-sm md:text-base font-medium ${
                  topic.hot ? 'text-primary-700' : 'text-foreground-700 group-hover:text-primary-500'
                } transition-colors`}>
                  #{topic.name}
                </span>
                <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded-full">
                  {topic.count}
                </span>
                {topic.hot && (
                  <i className="ri-fire-line text-xs text-primary-500"></i>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}